import { render, staticRenderFns } from "./HandlingUnitTypeSelect.vue?vue&type=template&id=5c3c448d&scoped=true&lang=pug"
import script from "./HandlingUnitTypeSelect.vue?vue&type=script&lang=js"
export * from "./HandlingUnitTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c448d",
  null
  
)

export default component.exports